import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { AppFooter } from '../../../CommonComponents/AppFooter/AppFooter';
import { PRIVACY_POLICY_URL } from '../../../CommonConstants';
import { selectVersion } from '../../ConsumerAreaSelector';
import { infoSelector } from '../../../App/AppSelector';
import { FooterDisclosures } from '../../../CommonComponents/FooterDisclosures/FooterDisclosures';
import { selectTermsAndConditionsUrl } from '../../../CommonSelectors/CommonAreaSelector';

export const ClientFooter = () => {
  const version = useSelector(selectVersion);
  const appInfo = useSelector(infoSelector);
  const websiteTermsAndConditionsUrl = useSelector(selectTermsAndConditionsUrl);

  return (
    <Box width="100%" m="auto">
      <FooterDisclosures />

      <AppFooter className="application-footer">
        <span className="application-footer-span">
          Copyright &copy; {ADV.info.CopyrightYear} Orion Advisor Technology, LLC &nbsp; {version}
        </span>

        {appInfo.ShowDisclosures && (
          <a href="/Legal/Disclosures" target="_blank">
            Disclosures
          </a>
        )}

        <a href={websiteTermsAndConditionsUrl} target="_blank" rel="noreferrer">
          Website Terms and Conditions
        </a>

        {appInfo.ShowPrivacyPolicy && (
          <a href={PRIVACY_POLICY_URL} rel="noreferrer" target="_blank">
            Privacy <span className="hide-on-mobile-screens">Policy</span>
          </a>
        )}
      </AppFooter>
    </Box>
  );
};
